export const defaultPageSize = 20

export const specialCountries = ["United States of America", "USA", "United States", "Canada", "China"];

export const CURRENCY_OPTIONS = [
    "USD",
    "EUR",
    "GBP",
    "JPY",
    "CAD",
    "AUD",
    "CHF",
    "CNY",
    "INR",
    "MXN",
    "BRL",
    "ZAR",
    "SEK",
    "NOK",
    "DKK",
    "PLN",
    "RUB",
    "TRY",
    "KRW",
    "SGD",
    "HKD",
    "NZD",
    "THB",
    "MYR",
    "PHP",
    "IDR",
    "VND",
  ];